import { useQuery } from "@apollo/client/react";

import { GET_COMPATIBLE_VERSIONS_FOR_UPDATE } from "./gql";

const useUpdateDeploymentCompatibleVersions = (templateId?: string, versionId?: string) => {
  return useQuery(GET_COMPATIBLE_VERSIONS_FOR_UPDATE, {
    variables: {
      id: templateId!,
      versionId: versionId!,
    },
    skip: !templateId || !versionId,
  });
};

export default useUpdateDeploymentCompatibleVersions;
